import { Box, Typography, Button } from "@mui/material";

export default function Error() {
  return (
    <Box
      sx={{
        height: "100vh",
        width:"100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
            background: "rgb(128, 99, 154)",

      }}
    >
      <Typography
        variant="h1"
        sx={{ fontWeight: "bold", fontSize: "120px", mb: 0 }}
      >
        404
      </Typography>

      <Typography variant="h5" sx={{ mt: -1, mb: 2 }}>
        الصفحة غير موجودة
      </Typography>

      <Typography variant="body1" sx={{ maxWidth: "400px", mb: 3 }}>
        يبدو أنك وصلت لصفحة غير صحيحة. تأكد من اسم الدولة أو ارجع للصفحة الرئيسية.
      </Typography>

      <Button variant="contained" size="large" href="/">
        الرجوع للصفحة الرئيسية
      </Button>
    </Box>
  );
}